import { render, staticRenderFns } from "./contact-form-normal.vue?vue&type=template&id=4a58da7a&scoped=true&"
import script from "./contact-form-normal.vue?vue&type=script&lang=js&"
export * from "./contact-form-normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58da7a",
  null
  
)

export default component.exports